<template>
  <div class="Index">
    <!-- <div class="content-box">
      <div class="go-back" @click="goback">返 回</div>
      <div class="routine-box"></div>
      <div class="routine-321"></div>
    </div> -->
    <div class="content-theme">
      <div class="content-theme-title">
        <div
          v-for="(item, index) in detailList"
          :key="index"
          :class="index === activeDetail ? 'active' : 'setting'"
          @click="handleDetailToggle(index)"
        >
          {{ item.label }}
        </div>
      </div>
    </div>

    <div class="content-theme-content">
      <div class="content-theme-content-title">
        <div v-for="(item, index) in questionToggleList" :key="index">
          <div class="questionList-title" @click="pageJumpUrl(item.url)">
            <div class="questionList-title-img">
              <div class="questionList-title-img-title">Q{{ index + 1 }}</div>
            </div>
            <div>{{ item.label }}</div>
            <img
              v-if="index < 3"
              class="questionList-title-fire"
              src="@/assets/modify/list/fire.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <div class="toggle-list">
      <div class="toggle-list-card" @click="toggleCardMode">
        <img
          class="toggle-list-card-img"
          src="@/assets/modify/list/card.png"
          alt=""
        />
        <div class="toggle-list-card-title">切换为卡片模式</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'list',
  data () {
    return {
      detailList: [
        {
          label: '认识手机',
          questionList: [
            { label: '认识手机常用图标?', url: '/recognize/iconIndex' },
            {
              label: '认识手机常用组件?',
              url: '/recognize/moduleIndex'
            },
            {
              label: '认识手机常用界面?',
              url: '/recognize/pageIndex'
            },
            { label: '认识手机常用软件?', url: '/recognize/softwareIndex' }
          ]
        },
        {
          label: '手机日常功能',
          questionList: [
            {
              label: '如何新增联系人或删除联系人?',
              url: '/use/contacts/index1'
            },
            {
              label: '如何将号码加入黑名单或解除黑名单?',
              url: '/use/blacklist/index1'
            },
            {
              label: '如何添加和呼叫紧急联系人?',
              url: '/use/emergency/index1'
            },
            {
              label: '如何设置闹钟?',
              url: '/use/alarmClock/index1'
            },
            { label: '如何使用手电筒?', url: '/use/flashlight/index1' },
            {
              label: '如何安装或卸载软件?',
              url: '/use/software/index1'
            }
          ]
        },
        {
          label: '手机基础设置',
          questionList: [
            { label: '如何连接无线网WIFI?', url: '/phoneSettings/wifi/index1' },
            { label: '如何清理手机存储空间?', url: '/phoneSettings/space/index' },
            {
              label: '如何设置手机开机解锁密码?',
              url: '/phoneSettings/password/index1'
            },
            { label: '如何调节屏幕的亮度和文字的大小?', url: '/phoneSettings/size/index1' },
            {
              label: '如何设置手机铃声?',
              url: '/phoneSettings/ringTone/index1'
            },
            { label: '如何查看和删除软件的通知消息?', url: '/phoneSettings/notice/index1' },
            {
              label: '如何开启手机的定位服务?',
              url: '/phoneSettings/permission/index'
            },
            { label: '如何移动手机桌面图标和新建文件夹?', url: '/phoneSettings/desktop/index1' },
            { label: '如何设置人脸登录?', url: '/phoneSettings/password/index1' },
            { label: '如何快速调节手机亮度?', url: '/phoneSettings/size/branch/index1' },
            { label: '如何快速切换震动、响铃、静音模式?', url: '/phoneSettings/ringTone/branch/index1' }
          ]
        },
        {
          label: '微信基础设置',
          questionList: [
            { label: '如何在微信中添加或删除好友?', url: '/wxSettings/friend/index1' },
            {
              label: '如何在微信聊天界面切换输入法?',
              url: '/wxSettings/input/index1'
            },
            {
              label: '如何发送语音和表情包?',
              url: '/wxSettings/expression/index3'
            },
            {
              label: '如何撤回已发送的消息?',
              url: '/wxSettings/expression/branch1/index1'
            },
            { label: '如何添加新的表情包?', url: '/wxSettings/expression/branch2/index1' },
            {
              label: '如何收藏别人发送的表情包?',
              url: '/wxSettings/expression/branch3/index1'
            },
            { label: '如何在微信聊天界面发起语音电话和视频聊天?', url: '/wxSettings/chat/index1' },
            {
              label: '如何在微信视频聊天时最小化窗口?',
              url: '/wxSettings/chat/branch/index1'
            }, // 12306添加乘车人
            {
              label: '如何在微信中发起和退出群聊?',
              url: '/wxSettings/groupChat/index1'
            }, // 12306改签
            {
              label: '如何修改微信群的名称?',
              url: '/wxSettings/groupChat/branch1/index1'
            }, // 12306退票
            { label: '如何设置微信群聊消息免打扰?', url: '/wxSettings/groupChat/branch2/index1' },
            {
              label: '如何发微信朋友圈?',
              url: '/wxSettings/weChat/index1'
            },
            {
              label: '如何点赞和评论别人的朋友圈?',
              url: '/wxSettings/weChat/index1'
            },
            {
              label: '如何清理微信存储空间?',
              url: '/wxSettings/space/index1'
            },
            {
              label: '如何开启微信关怀模式?',
              url: '/wxSettings/care/index1'
            }
          ]
        },
        {
          label: '手机金融与购物',
          questionList: [
            { label: '如何在微信和支付宝中绑定银行卡?', url: '/shopping/bankCard/index' },
            {
              label: '如何在微信和支付宝中实现转账?',
              url: '/shopping/transferAccounts/index'
            }, // 美团
            { label: '如何给微信好友发红包?', url: '/shopping/transferAccounts/wx/branch1/index1' },
            {
              label: '如何在微信群中给群友转账?',
              url: '/shopping/transferAccounts/wx/branch1/index1'
            },
            {
              label: '如何在微信群中给群友发红包?',
              url: '/shopping/transferAccounts/wx/branch3/index1'
            },
            {
              label: '如何使用支付宝转账给他人银行卡?',
              url: '/shopping/transferAccounts/zfb/branch/index1'
            },
            {
              label: '如何将支付宝余额提现到本人银行卡?',
              url: '/shopping/withdrawal/zfb/index1'
            },
            {
              label: '如何将微信余额提现到本人银行卡?',
              url: '/shopping/withdrawal/wx/index1'
            }, // 拼多多
            {
              label: '如何使用手机银行查看余额和交易明细?',
              url: '/shopping/details/index'
            }, // 拼多多
            {
              label: '如何使用手机银行转账给其他银行卡?',
              url: '/shopping/bankTransfer/index'
            },
            {
              label: '如何使用微信和支付宝扫码支付?',
              url: '/shopping/payment/index'
            },
            {
              label: '如何出示微信的付款码?',
              url: '/shopping/payment/wx/branch1/index1'
            },
            {
              label: '如何出示微信的收款码?',
              url: '/shopping/payment/wx/branch2/index1'
            },
            {
              label: '如何出示支付宝的付款码?',
              url: '/shopping/payment/zfb/branch1/index1'
            },
            {
              label: '如何出示支付宝的收款码?',
              url: '/shopping/payment/zfb/branch2/index1'
            },
            {
              label: '如何使用国家反诈中心APP?',
              url: '/shopping/antiFraudAPP/index1'
            }
          ]
        }
      ],
      // 激活对象
      activeDetail: 0,
      // 问题列表
      questionToggleList: [
        { label: '认识手机常用图标?', url: '/recognize/iconIndex' },
        {
          label: '认识手机常用组件?',
          url: '/recognize/moduleIndex'
        },
        {
          label: '认识手机常用界面?',
          url: '/recognize/pageIndex'
        },
        { label: '认识手机常用软件?', url: '/recognize/softwareIndex' }

      ]
    }
  },
  methods: {
    goback () {
      this.$router.replace({
        path: '/classification'
      })
    },
    handleDetailToggle (index) {
      this.activeDetail = index
      this.questionToggleList = this.detailList[index].questionList
    },
    toggleCardMode () {
      this.$router.replace({
        path: '/classification'
      })
    },
    pageJumpUrl (url) {
      this.$router.push({
        path: url
      })
    }
  }
}
</script>

<style scoped lang="less">
.Index {
  position: relative;
  width: 100%;
  height: 100%;
  background: url(@/assets/modify/mainBg/rectangle_20250106.png) no-repeat
    center;
  background-size: 100% 100%;
  border-radius: 0px;
}
.content-box {
  display: flex;
  justify-content: space-evenly;
  padding-top: 40px;
  box-sizing: border-box;
}

.content-theme {
  width: 100%;
  .content-theme-title {
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    font-size: 25px;
    padding-top: 70px;
    box-sizing: border-box;
  }
}
.setting {
  color: rgb(73, 99, 255);
  width: 122px;
  height: 75px;
  text-align: center;
  background: url(@/assets/modify/list/group-11-2.png) no-repeat;
  background-size: 100% 100%;
  font-weight: bold;
  //超出两行省略号
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  -webkit-line-clamp: 2; //显示几行
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border-radius: 15px;
  border: 1px solid rgb(192, 216, 255);
  box-shadow: 0px 8px 17px 0px rgba(135, 134, 242, 0.35);
}
.active {
  color: #fef6ea;
  width: 122px;
  height: 75px;
  text-align: center;
  background: url(@/assets/modify/list/group-11.png) no-repeat;
  background-size: 100% 100%;
  font-weight: bold;
  //超出两行省略号
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  -webkit-line-clamp: 2; //显示几行
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border-radius: 15px;
  border: 1px solid rgb(172, 203, 255);
  box-shadow: 0px 8px 17px 0px rgba(60, 60, 231, 0.35);
}
.content-theme-content {
  width: 95%;
  height: 70%;
  margin: 0 auto;
  overflow-y: auto;
  margin-top: 40px;
}
.content-theme-content-title {
  // height: 100%;
  margin: 0 30px;
  box-sizing: border-box;
}
.questionList-title {
  border-radius: 15px;
  box-shadow: 0px 14px 23px -9px rgba(0, 0, 0, 0.09);
  background: rgb(255, 255, 255);
  width: 100%;
  height: 90px;
  font-size: 30px;
  color: #373737;
  box-sizing: border-box;
  display: flex;
  margin-top: 20px;
  align-items: center;
}
.questionList-title-fire {
  width: 35px;
  height: 35px;
  margin-left: 15px;
  // margin-top: 12px;
}
.questionList-title-img {
  width: 45px;
  height: 45px;
  margin: 0px 20px 0 30px;
  background: url(@/assets/modify/list/group-4.png) no-repeat center;
  background-size: 100% 100%;
}
.questionList-title-img-title {
  color: #d3f0e1;
  margin-top: 7px;
  font-size: 16px;
  margin-left: 6px;
}
.toggle-list {
  // margin: 15px 0;
}
.toggle-list-card {
  width: 60%;
  height: 100px;
  line-height: 100px;
  margin: 0 auto;
  background: url(@/assets/modify/list/group-26.png) no-repeat center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 35px;
  color: #ffffff;
  margin-top:13px;
}
.toggle-list-card-img {
  width: 50px;
  height: 50px;
margin-right: 10px;
}

</style>
